module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-MC.3869e538.png";